/**
 * なんらかのエラーが発生した際に、HTMLでエラーダイアログを表示し、
 * リロードやTopに戻すUIを提供する
 */
export class WidgetErrorDialog extends HTMLElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow({mode: 'open'});

    // (1) このカスタム要素の文書構造を定義する
    shadowRoot.innerHTML = `
            <dialog id="container">
                <div id="message">
                エラーが発生しました<br>
                エラーコード:<br>
                <span id="errorCode"></span>
                </div>
                <div id="buttons">
                    <input type="button" id="reload" class="error_button" value="再読み込み">
                    <input type="button" id="top" class="error_button" value="Topへ移動">
                </div>
            </dialog>
            `;

    const reloadButton = shadowRoot.querySelector('#reload');
    if (reloadButton) {
      reloadButton.addEventListener('click', () => {
        window.location.reload();
      });
    }

    const style = document.createElement('style');
    style.textContent = `
        #container {
            min-width: 200px;
            border-width: 1px;
            border-color: white;
            border-radius: 20px;
            background-color: #1A1B28;
            padding: 10px;
        }

        #message {
            color: white;
            padding: 10px;
        }

        #buttons {
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
        }

        .error_button {
            border-radius:20px;
            font-size:16px;
            background-color:white;
            padding:5px 20px;
        }

        #top {
            display:none;
        }
        `;
    shadowRoot.append(style);
  }

  setData(setting: {url?: string; buttonText?: string}) {
    const topButton = this.shadowRoot?.getElementById('top');
    if (topButton && topButton instanceof HTMLInputElement) {
      const url = setting.url;
      if (url) {
        topButton.style.display = 'block';
        topButton.addEventListener('click', () => {
          window.location.href = url;
        });
      }

      const buttonText = setting.buttonText;
      if (buttonText) {
        topButton.value = buttonText;
      }
    }
  }

  show(errorCode: string, detail: string = '') {
    // テキストとして対応
    const errorCodeElement = this.shadowRoot?.getElementById('errorCode');
    if (errorCodeElement) {
      if (errorCodeElement.innerText !== '') {
        errorCodeElement.innerText += '\n';
      }

      if (detail !== '') {
        errorCode += ':' + detail;
      }
      errorCodeElement.innerText += errorCode;
    }

    const dialog = this.shadowRoot?.querySelector('#container');
    if (dialog && dialog instanceof HTMLDialogElement) {
      dialog.showModal();
    }
  }
}

/**
 * 致命的なエラーダイアログの設定
 * @remarks
 * JSまたはHSから参照の想定
 */
export const hel_set_fatal_error_dialog = () => {
  const customElementName = 'widget-error-dialog';
  const widgetErrorDialog = document.createElement(customElementName);
  document.body.appendChild(widgetErrorDialog);
  if (!customElements.get(customElementName)) {
    customElements.define(customElementName, WidgetErrorDialog);
  } else {
    console.error('widget-error-dialog is already defined');
  }
  customElements.upgrade(widgetErrorDialog);
};

/**
 * メッセージダイアログを出す
 * @remarks
 * エラーによりインゲームが進行不能になったときに出す
 */
export const hel_show_fatal_error_dialog = (errorCode: string, detail: string = '') => {
  const customElementName = 'widget-error-dialog';
  const widgetErrorDialog: WidgetErrorDialog | null = document.querySelector(customElementName);
  if (widgetErrorDialog) {
    widgetErrorDialog.show(errorCode, detail);
  } else {
    console.debug('hel_set_fatal_error_dialog yet');
  }
};
